import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const comparisons = [{
  bad: 'Notti intere a costruire verifiche sul Bilancio da zero.',
  good: 'Verifiche e soluzionari pronti sul tuo tablet in 2 clic.'
}, {
  bad: 'Stress prima di spiegare la Partita Doppia a classi distratte.',
  good: 'Sicurezza totale con schemi visivi che semplificano la contabilità.'
}, {
  bad: 'Spiegazioni teoriche che la Gen Z trova "impossibili".',
  good: 'Supporti visivi moderni: 60% schemi e mappe / 40% testo.'
}, {
  bad: 'Frustrazione per la burocrazia del MIM e le UDA da riscrivere.',
  good: 'UDA, griglie ministeriali e programmazione annuale già integrate.'
}, {
  bad: 'Weekend sacrificati a correggere bilanci e costruire verifiche.',
  good: 'Verifiche pronte con soluzionario: correggi in metà del tempo.'
}, {
  bad: 'Difficoltà a coinvolgere studenti DSA e BES con la stessa verifica.',
  good: 'Schede differenziate Base / Intermedio / Avanzato già pronte.'
}];
export function ComparisonTable() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-56">
      <div className="max-w-5xl mx-auto" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-58">
          <p className="text-xs font-black uppercase tracking-widest text-brand-orange mb-3" data-id="element-59">
            La trasformazione
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-brand-cream leading-tight" data-id="element-60">
            Smetti di reinventare la ruota{' '}
            <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-61">
              ogni settimana
            </span>
            .
          </h2>
          <p className="text-base sm:text-lg text-gray-400 mt-3" data-id="element-62">
            Riprenditi il tuo tempo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-4" data-id="element-63">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#1a0f0a] border border-red-900/50 rounded-2xl p-6 sm:p-8" data-id="element-64">
            <h3 className="text-2xl font-black text-red-500 mb-6 text-center uppercase tracking-wide" data-id="element-65">
              ❌ Senza il Metodo
            </h3>
            <div className="space-y-4" data-id="element-66">
              {comparisons.map((item, i) => <div key={i} className="flex gap-3 items-start" data-id="element-67">
                  <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-68">
                    <XIcon className="w-5 h-5 text-red-500" data-id="element-69" />
                  </div>
                  <p className="text-gray-300 font-medium" data-id="element-70">{item.bad}</p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-[#1a140a] to-[#0f0a05] border border-brand-orange/50 rounded-2xl p-6 sm:p-8 shadow-[0_0_30px_rgba(249,115,22,0.15)] relative overflow-hidden" data-id="element-71">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-orange to-brand-gold" data-id="element-72" />
            <h3 className="text-2xl font-black text-brand-gold mb-6 text-center uppercase tracking-wide" data-id="element-73">
              ✅ Con il Metodo
            </h3>
            <div className="space-y-4" data-id="element-74">
              {comparisons.map((item, i) => <div key={i} className="flex gap-3 items-start" data-id="element-75">
                  <div className="mt-1 bg-green-500/20 p-1 rounded-full shrink-0" data-id="element-76">
                    <CheckIcon className="w-5 h-5 text-green-500" data-id="element-77" />
                  </div>
                  <p className="text-brand-cream font-bold" data-id="element-78">{item.good}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}